import Vue from 'vue';
import moment from 'moment';

export default {
  state: {
    randomMessageIndex: null,
    randomMessageIndexTimestamp: null,
    teamOverviewSettings: {
      selectedAthletes: null,
      selectedDateRange: {
        start: moment().subtract(30, 'days').format(),
        end: moment().format(),
      },
    },
  },
  getters: {
    randomMessageIndex: state => state.randomMessageIndex,
    teamOverviewSettings: (state) => {
      /* KLUDGE The length of the date range should be stored here, but we were already storing
       * the actual date range, so just recalculate the dates using the two stored dates */
      const range = state.teamOverviewSettings.selectedDateRange;
      const numDays = moment(range.end).diff(moment(range.start), 'days');
      const ret = JSON.parse(JSON.stringify(state.teamOverviewSettings));
      ret.selectedDateRange = {
        start: moment().subtract(numDays, 'days').format(),
        end: moment().format(),
      };
      return ret;
    },
  },
  mutations: {
    clearApp(state) {
      Vue.set(state, 'randomMessageIndex', null);
      Vue.set(state, 'randomMessageIndexTimestamp', null);
    },
    updateRandomMessageIndex(state, index) {
      if (moment().startOf('day').format() !== state.randomMessageIndexTimestamp) {
        Vue.set(state, 'randomMessageIndex', index);
        Vue.set(state, 'randomMessageIndexTimestamp', moment().startOf('day').format());
      }
    },
    updateTeamOverviewSettings(state, settings) {
      Vue.set(state, 'teamOverviewSettings', Object.assign(state.teamOverviewSettings, settings));
    },
  },
  actions: {
    clearApp(context) {
      context.commit('clearApp');
    },
    generateRandomMessageIndex(context) {
      context.commit('updateRandomMessageIndex', Math.floor(Math.random() * 3));
    },
    addTeamOverviewSelectedAthlete(context, memberId) {
      const selectedAthletes = JSON.parse(JSON.stringify(
        context.getters.teamOverviewSettings.selectedAthletes,
      ));
      if (!selectedAthletes.includes(memberId)) {
        selectedAthletes.push(memberId);
        context.commit('updateTeamOverviewSettings', { selectedAthletes });
      }
    },
    removeTeamOverviewSelectedAthlete(context, memberId) {
      const selectedAthletes = JSON.parse(JSON.stringify(
        context.getters.teamOverviewSettings.selectedAthletes,
      ));
      selectedAthletes.splice(selectedAthletes.indexOf(memberId), 1);
      context.commit('updateTeamOverviewSettings', { selectedAthletes });
    },
  },
};
